module.exports = __webpack_public_path__ + "static/media/filled_bar_liquidStrip.3ad08d12.svg";